module.exports = __webpack_public_path__ + "img/auth0-logo.3fc94d32.png";